export interface SupabaseResourceErrorLike {
  code?: string;
  message?: string;
  details?: string;
}

const MISSING_RESOURCE_PREFIX = 'personalinsights:missing-supabase-resource:';

export function isMissingSupabaseResource(error: SupabaseResourceErrorLike | null) {
  return (
    error?.code === 'PGRST202' ||
    error?.code === 'PGRST205' ||
    error?.code === '42P01' ||
    error?.code === '42883'
  );
}

function getMissingResourceStorageKey(resourceName: string, userId: string) {
  return `${MISSING_RESOURCE_PREFIX}${userId}:${resourceName}`;
}

export function isSupabaseResourceMarkedMissing(
  resourceName: string,
  userId: string | null | undefined
) {
  if (typeof window === 'undefined' || !userId) return false;
  try {
    return (
      window.sessionStorage.getItem(getMissingResourceStorageKey(resourceName, userId)) === '1'
    );
  } catch {
    return false;
  }
}

export function markSupabaseResourceMissing(
  resourceName: string,
  userId: string | null | undefined
) {
  if (typeof window === 'undefined' || !userId) return;
  try {
    window.sessionStorage.setItem(getMissingResourceStorageKey(resourceName, userId), '1');
  } catch {
    // Ignore sessionStorage issues and fall back to in-memory behavior.
  }
}

export function clearSupabaseResourceMissing(
  resourceName: string,
  userId: string | null | undefined
) {
  if (typeof window === 'undefined' || !userId) return;
  try {
    window.sessionStorage.removeItem(getMissingResourceStorageKey(resourceName, userId));
  } catch {
    // Ignore sessionStorage issues and fall back to in-memory behavior.
  }
}
